import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as contractSelector from './contract.selector';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class ContractStore {
	contracts$ = this.store.select(contractSelector.getUserContracts);
	contracts = toSignal(this.contracts$);
	getContractById(id: string) {
		return this.store.selectSignal(contractSelector.getContractById(id));
	}
	optionBuyContractState$ = this.store.select(contractSelector.getBuyTradeOptionContractState);
	optionSellContractState$ = this.store.select(contractSelector.getSellTradeOptionContractState);

	constructor(private store: Store) {}
}
